// Total number of monthly payments
import { MATURITY_YEARS } from '../../constants';

export const getNumberOfPayments = (maturity = MATURITY_YEARS) => maturity * 12;
